import { ProgressBar, Text } from "@blueprintjs/core"
import CustomCard from "components/Atoms/CustomCard"
import { isFunction } from "lodash-es"
import React from "react"

interface InwardSummaryCardProps {
  unit?: any
  intent?: any
  progress?: number
  stripes?: boolean
  title?: string | any
  to?: number
  value?: React.ReactNode
  showProgress?: boolean
  subtitle?: any
  children?: React.ReactNode
}
const InwardSummaryCard = ({
  unit,
  intent,
  progress,
  stripes,
  title,
  to,
  value,
  children,
  showProgress,
  subtitle,
}: InwardSummaryCardProps) => {
  const progressIntent: any =
    intent && Object.keys(intent).find((i: any) => intent[i])

  return (
    <CustomCard className="vt-inward-summary-card h-full">
      <h6>
        {title} {unit && <span className="vt-kg">({unit})</span>}
      </h6>
      {subtitle && <p className="subtitle">{subtitle}</p>}{" "}
      {children && isFunction(children) ? (
        children(progressIntent)
      ) : (
        <Text ellipsize={true}>
          <p>
            <span className={`vt-${progressIntent}`}>{value} </span>
            {to && <span>/ {to}</span>}
          </p>
        </Text>
      )}
      {showProgress && (
        <ProgressBar
          stripes={stripes}
          value={progress}
          intent={progressIntent}
          className="vt-progress-bar"
        />
      )}
    </CustomCard>
  )
}
InwardSummaryCard.defaultProps = {
  showProgress: true,
}
export default InwardSummaryCard
